import { Device, until } from '@helpers/media';
import { useResize } from '@hooks/useResize';
import { useScrollDirection } from '@hooks/useScrollDirection';
import SvgAngleDown from '@img/icons/angle-down.svg';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import SvgExternal from '@img/icons/external.svg';
import * as React from 'react';
import S from './SecondaryNavigation.styles';
const SecondaryNavigation = ({ secondaryItems, signIn, setOpenModal }) => {
    const navRef = React.useRef(null);
    const scrollDirection = useScrollDirection(50);
    const [visible, setVisible] = React.useState(true);
    const removeVariable = () => {
        const documentStyle = document.documentElement.style;
        if (documentStyle.getPropertyValue('--headerTopBarHeight')) {
            document.documentElement.style.removeProperty('--headerTopBarHeight');
            setVisible(true);
        }
    };
    useResize({
        callback: removeVariable,
        debounce: 100,
        immediate: true,
        on: 'x',
    });
    React.useEffect(() => {
        const nav = navRef.current;
        const isMobile = window.matchMedia(`${until(Device.TabletLarge)}`).matches;
        if (!nav || isMobile) {
            return;
        }
        if (scrollDirection === 'down') {
            document.documentElement.style.setProperty('--headerTopBarHeight', '0px');
            setVisible(false);
        }
        else {
            document.documentElement.style.setProperty('--headerTopBarHeight', '40px');
            setVisible(true);
        }
    }, [scrollDirection]);
    if (!secondaryItems || secondaryItems.length === 0) {
        return null;
    }
    return (React.createElement(S.Nav, { ref: navRef, "aria-label": "Secondary Desktop Navigation", "data-visible": visible },
        React.createElement(S.List, null,
            signIn && signIn.buttonText &&
                React.createElement(S.Item, null,
                    React.createElement(S.LinkButton, { type: 'button', onClick: () => setOpenModal() },
                        React.createElement("span", null, signIn.buttonText))),
            secondaryItems.map((item) => (React.createElement(S.Item, { key: item.id },
                React.createElement(S.Link, { href: item.url, target: item.target ?? '_self' },
                    item.text,
                    !!item.children?.length && React.createElement(SvgAngleDown, null)),
                !!item.children?.length && (React.createElement(S.DropdownList, null, item.children.map((child) => (React.createElement(S.DropdownItem, { key: child.id },
                    React.createElement(S.DropdownLink, { href: child.url, target: child.target ?? '_self' },
                        child.text,
                        item.text.toLowerCase().includes('sign') ? (React.createElement(SvgExternal, null)) : (React.createElement(SvgArrowRight, null))))))))))))));
};
export default SecondaryNavigation;
